module.exports = ["xx-small","x-small","small","medium","large","x-large","xx-large","larger","smaller"]


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-font-size-keywords/index.json
// module id = 1085
// module chunks = 0